<template>
    <div id="div-with-loading" class="vs-con-loading__container">
        <div class="view-agts">
            <div class="form-actions flex justify-between w-full items-center">
                <div class="flex vx-col-action">
                    <vs-input icon-pack="feather" icon="icon-search" placeholder="Type here..." v-model="globalSearchTerm" class="is-label-placeholder searchBar-input" id="filter-text-box" v-on:input="onFilterTextBoxChanged()" />

                    <span class="br-line mr-2 ml-2"></span>
                </div>
                
                <div class="float-right flex">
                    <vx-tooltip class="content-center" text="Add Agreement" position="top" v-if="isLocalRule">
                        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus" @click="addAgreements()">Add Agreement</vs-button>
                    </vx-tooltip>
                    <vx-tooltip text="Download list" position="top">
                        <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-download" @click="downloadData()"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip text="Reset Filters" position="top">
                        <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-refresh-ccw" @click="refreshPageWithFilters()"></vs-button>
                    </vx-tooltip>
                </div>
            </div>

            <div class="agt-list-wrap pb-5">
                <div id="grid-loader" class="vx-card vs-con-loading__container">
                    <ag-grid-vue :gridOptions="gridOptions" class="ag-theme-material w-100 ag-grid-table ag-agreement-list-table" :columnDefs="columnDefs" :defaultColDef="defaultColDef" :components="components" :rowData="tableData" rowSelection="multiple" :enableRangeSelection="true" :suppressCopyRowsToClipboard="true" :suppressDragLeaveHidesColumns="true" :animateRows="false" :floatingFilter="true" :pagination="true" :paginationPageSize="paginationPageSize" :suppressPaginationPanel="true" :suppressRowClickSelection="true" :rowClassRules="rowClassRules" :statusBar="statusBar" :sideBar="sideBar" :rowHeight="35" :headerHeight="35" :floatingFiltersHeight="35" @pagination-changed="onPaginationChanged" @column-resized="onColumnResized">
                    </ag-grid-vue>

                    <div class="vx-row py-5">
                        <div class="vx-col w-full">
                            <vs-pagination :total="totalPages" :max="maxPageNumbers" class="custom-pagination" v-model="currentPage" />
                        </div>
                    </div>
                </div>
            </div>
            <!-- New Agreement Component -->
            <UploadAgreement></UploadAgreement>
        </div>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import "@/assets/scss/radix/extraComponents/agGridStyleOverride.scss";

import UploadAgreement from "@/components/UploadAgreement.vue";
import CellRendererViewAndEditActions from "@/components/ag-grid-tables/actions/CellRendererViewAndEditActions.vue";
import moment from 'moment';

export default {
    name: 'AgreementList',
    components: {
        AgGridVue,
        UploadAgreement,
        CellRendererViewAndEditActions
    },
    data() {
        return {
            autoGroupColumnDef: null,
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            globalSearchTerm: "",
            defaultColDef: {
                sortable: true,
                resizable: true,
                suppressMenu: true,
                suppressMovable: false,
                filterParams: {
                    suppressAndOrCondition: true,
                    newRowsAction: "keep",
                },
            },
            // Cell Renderer Components
            components: {},
            rowClassRules: null,
            statusBar: null,
            sideBar: null,
            columnDefs: null,
            tableData: []
        };
    },
    watch: {
        windowWidth(val) {
            // Toggle colummn movable
            this.toggleColumnMovable(val);
            // Toggle colummn pinning
            this.toggleColumnPinned(val);
        },
    },
    computed: {
        windowWidth: function () {
            return this.$store.state.windowWidth;
        },
        user_role() {
            return JSON.parse(localStorage.getItem("userDetails")).role;
        },
        user_id() {
            return JSON.parse(localStorage.getItem("userDetails")).id;
        },
        paginationPageSize() {
            if (this.gridApi) {
                return this.gridApi.paginationGetPageSize();
            } else {
                return 15;
            }
        },
        totalPages() {
            if (this.gridApi) {
                return this.gridApi.paginationGetTotalPages();
            } else {
                return 0;
            }
        },
        currentPage: {
            get() {
                if (this.gridApi)
                    return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1;
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1);
            },
        },
        isLocalRule() {
            return this.$acl.check('isSuperAdmin') || this.$acl.check('isChannelAdmin') || this.$acl.check('isChannelUser') || this.$acl.check('isBIAdmin');
        },
    },
    beforeMount() {
        // Table Data AXIOS Call
        this.populateTableData()
            .then(() => {
                this.filterTableData();
            })
            .catch((err) => {
                console.log("err :>> ", err);
            });

        // Reset movable columns on mobile
        this.toggleColumnMovable(this.windowWidth);

        this.columnDefs = [
            {
                headerName: "Partner",
                field: "partner_name",
                filter: "agSetColumnFilter",
                // cellClass: "cellCustomWrap",
                pinned: "left",
                minWidth: 200,
                width: 200,
                cellClass: "v-center-cell"
            },
            {
                headerName: "Type",
                field: "type",
                filter: "agSetColumnFilter",
                // tooltipValueGetter: (params) => params.data.type,
                pinned: "left",
                minWidth: 180,
                width: 250,
                cellClass: "v-center-cell"
            },
            {
                headerName: "Agreement Name",
                field: "filename",
                filter: "agSetColumnFilter",
                minWidth: 300,
                width: 300,
                autoHeight: true,
                wrapText: true,
                cellClass: "cellCustomWrap",
                // cellStyle:  { 'overflow-y': 'scroll' },
                cellRenderer: (data) => {
                    let content = "";
                    data.data.dropbox_detail.forEach((el, index) => {
                        content += index > 0 ? ", <br>" : "";
                        content += "<a href=" + el.dropbox_link + " target='_blank' class='cellAgtName'>" + el.filename + "</a>"
                    })
                    return content;
                },
                valueGetter: (data) => {
                    let content = "";
                    data.data.dropbox_detail.forEach((el, index) => {
                        content += index > 0 ? ", " : "";
                        content += el.filename;
                    })
                    return content;
                },
            },
            {
                headerName: "AM",
                field: "partner_user",
                filter: "agSetColumnFilter",
                minWidth: 150,
                cellRenderer: (data) => {
                    if (data.data.partner_user) {
                        return data.data.partner_user;
                    } else {
                        return "-";
                    }
                },
                cellClass: "v-center-cell"
            },
            {
                headerName: "Start Date",
                field: "start_date",
                filter: "agDateColumnFilter",
                minWidth: 175,
                filterParams: {
                    comparator: function (
                        filterLocalDateAtMidnight,
                        cellValue
                    ) {
                        let dateAsString = cellValue;
                        if (dateAsString == null) return -1;
                        let dateParts = dateAsString.split("-");
                        let cellDate = new Date(
                            Number(dateParts[0]),
                            Number(dateParts[1]) - 1,
                            Number(dateParts[2])
                        );
                        if (
                            filterLocalDateAtMidnight.getTime() ===
                            cellDate.getTime()
                        ) {
                            return 0;
                        }
                        if (cellDate < filterLocalDateAtMidnight) {
                            return -1;
                        }
                        if (cellDate > filterLocalDateAtMidnight) {
                            return 1;
                        }
                    },
                    browserDatePicker: true,
                },
                cellClass: "v-center-cell"
            },
            {
                headerName: "End Date",
                field: "end_date",
                filter: "agDateColumnFilter",
                minWidth: 175,
                filterParams: {
                    comparator: function (
                        filterLocalDateAtMidnight,
                        cellValue
                    ) {
                        let dateAsString = cellValue;
                        if (dateAsString == null) return -1;
                        let dateParts = dateAsString.split("-");
                        let cellDate = new Date(
                            Number(dateParts[0]),
                            Number(dateParts[1]) - 1,
                            Number(dateParts[2])
                        );
                        if (
                            filterLocalDateAtMidnight.getTime() ===
                            cellDate.getTime()
                        ) {
                            return 0;
                        }
                        if (cellDate < filterLocalDateAtMidnight) {
                            return -1;
                        }
                        if (cellDate > filterLocalDateAtMidnight) {
                            return 1;
                        }
                    },
                    browserDatePicker: true,
                },
                cellClass: "v-center-cell"
            },
            {
                headerName: "Upload date",
                field: "updated_at",
                filter: "agSetColumnFilter",
                minWidth: 175,
                cellRenderer: (data) => {
                    return moment(data.data.updated_at).format('YYYY-MM-DD')
                },
                valueGetter: (data) => {
                    return moment(data.data.updated_at).format('YYYY-MM-DD')
                },
                filterParams: {
                    comparator: function (
                        filterLocalDateAtMidnight,
                        cellValue
                    ) {
                        let dateAsString = cellValue;
                        if (dateAsString == null) return -1;
                        let dateParts = dateAsString.split("-");
                        let cellDate = new Date(
                            Number(dateParts[0]),
                            Number(dateParts[1]) - 1,
                            Number(dateParts[2])
                        );
                        if (
                            filterLocalDateAtMidnight.getTime() ===
                            cellDate.getTime()
                        ) {
                            return 0;
                        }
                        if (cellDate < filterLocalDateAtMidnight) {
                            return -1;
                        }
                        if (cellDate > filterLocalDateAtMidnight) {
                            return 1;
                        }
                    },
                    browserDatePicker: true,
                },
                cellClass: "v-center-cell"
            },
            {
                headerName: "Total Amount",
                field: "",
                filter: "agSetColumnFilter",
                minWidth: 150,
                cellRenderer: (data) => {
                    if (data.data.agreement_detail && data.data.agreement_detail.length) {
                        return decodeURI(data.data.currency.sign) + " " + 
                        Number(parseFloat(data.data.agreement_detail[0].total_amount).toFixed(2)).toLocaleString('en', {
                            minimumFractionDigits: 2
                        });
                    } else {
                        return 0;
                    }
                },
                valueGetter: (data) => {
                    if (data.data.agreement_detail && data.data.agreement_detail.length) {
                        return decodeURI(data.data.currency.sign) + " " + 
                        Number(parseFloat(data.data.agreement_detail[0].total_amount).toFixed(2)).toLocaleString('en', {
                            minimumFractionDigits: 2
                        });
                    } else {
                        return 0;
                    }
                },
                cellClass: "v-center-cell"
            },
            {
                headerName: "Total Converted Amount",
                field: "",
                filter: "agSetColumnFilter",
                minWidth: 150,
                cellRenderer: (data) => {
                    if (data.data.agreement_detail && data.data.agreement_detail.length) {
                        return "$ " + 
                        Number(parseFloat(data.data.agreement_detail[0].total_converted_amount).toFixed(2)).toLocaleString('en', {
                            minimumFractionDigits: 2
                        });
                    } else {
                        return 0;
                    }
                },
                valueGetter: (data) => {
                    if (data.data.agreement_detail && data.data.agreement_detail.length) {
                        return "$ " +
                        Number(parseFloat(data.data.agreement_detail[0].total_converted_amount).toFixed(2)).toLocaleString('en', {
                            minimumFractionDigits: 2
                        });
                    } else {
                        return 0;
                    }
                },
                cellClass: "v-center-cell"
            },
            {
                headerName: "Provisional",
                field: "provisional",
                filter: "agSetColumnFilter",
                minWidth: 150,
                valueGetter: (data) => {
                    if (data.data.provisional) {
                        return "Yes";
                    } else {
                        return "No";
                    }
                },
                cellRenderer: (data) => {
                    if (data.data.provisional) {
                        return "Yes";
                    } else {
                        return "No";
                    }
                },
                cellClass: "v-center-cell"
            },
            {
                headerName: "Actions",
                field: "actions",
                pinned: "right",
                cellRendererFramework: "CellRendererViewAndEditActions",
                minWidth: 150,
                hide: !this.isLocalRule,
                cellClass: "v-center-cell"
            },
        ];
    },
    mounted() {
        this.gridApi = this.gridOptions.api;

        //agigrid loader
        this.gridApi.showLoadingOverlay();

        // Resize to fit columns
        this.sizeColumnsToFit();

        // Reset pinned columns on mobile
        this.toggleColumnPinned(this.windowWidth);

        this.$root.$on("downloadAgreementList", () => {
            // AgGrid CSV Export
            this.gridApi.exportDataAsCsv();
        });

        this.$root.$on("tableRefresh", () => {
            // console.log('refresh Table Data');
            this.populateTableData();
        });
    },
    methods: {
        openLoadingInDiv() {
            this.$vs.loading({
                container: "#div-with-loading",
                scale: 0.8,
            });
        },
        hideLoadingInDiv() {
            this.$vs.loading.close("#div-with-loading > .con-vs-loading");
        },
        onPageSizeChanged(newPageSize) {
            var value = document.getElementById("page-size").value;
            this.gridApi.paginationSetPageSize(Number(value));
        },
        onPaginationChanged() {
            // console.log('pagechanges');
            if (this.gridApi) {
                (this.totalRows = this.gridApi.paginationGetRowCount()),
                    (this.currentPageSize =
                        this.gridApi.paginationGetPageSize());
            }
        },
        toggleColumnMovable(val) {
            if (val <= 576) {
                this.defaultColDef["suppressMovable"] = true;
            } else {
                this.defaultColDef["suppressMovable"] = false;
            }
        },
        toggleColumnPinned(val) {
            if (val <= 576) {
                this.maxPageNumbers = 4;
                this.gridOptions.columnApi.setColumnPinned("domain", null);
            } else {
                this.gridOptions.columnApi.setColumnPinned("domain", "left");
            }
        },
        onFilterTextBoxChanged() {
            this.gridApi.setQuickFilter(
                document.getElementById("filter-text-box").value
            );
        },
        onColumnResized() {
            this.gridApi.resetRowHeights();
        },
        sizeColumnsToFit() {
            this.gridApi.sizeColumnsToFit();
        },
        populateTableData() {
            return new Promise((resolve, reject) => {
                let self = this;

                /* Get table data */
                this.$axiosSecure.get("/agreements/approved")
                .then((response) => {
                    this.tableData = response.data;

                    for (var key in response.data) {
                        if (response.data[key].unique_registrar_id) {
                            //Client name
                            response.data[key].partner_name =
                                response.data[key].unique_registrar.name;
                            //User name
                            if (response.data[key].unique_registrar.unique_registrar_client_am.length &&
                                response.data[key].unique_registrar.unique_registrar_client_am[0].user_id &&
                                response.data[key].unique_registrar.unique_registrar_client_am[0].user
                            ) {
                                response.data[key].partner_user =
                                    response.data[key].unique_registrar.unique_registrar_client_am[0].user.name;
                            } else {
                                response.data[key].partner_user = null;
                            }
                        } else {
                            response.data[key].partner_name =
                                response.data[key].new_reseller.name;
                            if (response.data[key].new_reseller.new_reseller_client_am.length && response.data[key].new_reseller.new_reseller_client_am[0].user_id) {
                                response.data[key].partner_user =
                                    response.data[key].new_reseller.new_reseller_client_am[0].user.name;
                            } else {
                                response.data[key].partner_user = null;
                            }
                        }
                    }
                    resolve(true);
                })
                .catch((error) => {
                    // Error notification
                    self.$vs.notify({
                        color: "danger",
                        title: "Something went wrong",
                        text: "Please contact the server admin",
                    });

                    console.log(error);

                    // Clear Listing Count
                    this.$store.dispatch("clearListingCount");

                    reject(error);
                });
            });
        },
        addAgreements() {
            this.$root.$emit("openAgtPopup", "new");
        },
        filterTableData() {
            let clientId = this.$route.params.client_id;

            if (clientId) {
                this.tableData = this.tableData.filter(
                    (x) =>
                        x["partner_name"] ===
                        clientId.split("-")[clientId.split("-").length - 1]
                );
            }
        },
        showAllAgreements() {
        },
        downloadData() {
            this.$root.$emit("downloadAgreementList");
        },
        refreshPageWithFilters() {
            // Reset filters
            this.gridApi.setFilterModel(null);
            // Reset selection
            this.gridApi.deselectAll();
            // Reset sort
            this.gridApi.setSortModel(null);
            // Table Data AXIOS Call
            this.populateTableData();
        },
    },
    destroyed() {
        // Clear Listing Count
        this.$store.dispatch("clearListingCount");
        // Unbind Button Event Listeners
        this.$root.$off("downloadAgreementList");
        this.$root.$off("tableRefresh");
    },
};
</script>
